import $axios from "../../api/axios";

function getListApi({ callback }) {
  $axios
    .post("/api/contacts")
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function contactAgentApi({ params, callback }) {
  $axios
    .post(`/api/agent/contact-agent-email/${params.id}`, params.data)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getListApi,
  contactAgentApi
};



// WEBPACK FOOTER //
// ./src/api/contact/contact.js